import styled from 'styled-components';

export const StyledBreadcrumb = styled.nav``;
